<!-- 列表单元格 -->
<template>
  <van-col class="teas-card-desc-item mobile" :span="col || 24">
    <slot name="icon">
      <i v-if="icon" class="teas-card-desc-item-icon" :class="['iconfont', icon]"></i>
    </slot>
    <slot name="label">
      <span v-if="label" class="teas-card-desc-item-label">
        {{ label }}
      </span>
    </slot>
    <slot name="value">
      <span class="teas-card-desc-item-value">{{ value }}</span>
    </slot>
  </van-col>
</template>

<script>
// 数据格式案例
const testData = {
  col:24,
  label: "授课老师：",
  value: "张三",
  icon: "icon-yzkb", // icon的name
};

export default dsf.component({
  name: "DsfMobileTeasCardDescItem",
  ctrlCaption: "描述卡片的列表item",
  mixins: [$mixins.control],
  design: {},
  props: {
    // 栅格化，总数为24
    col:{
      type:Number,
      default: 24
    },
    // label
    label: {
      type: String,
      default: '',
    },
    // value
    value: {
      type: String,
      default: '',
    },
    // icon
    icon: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  created() {
  },
  mounted() {},
  methods: {},
});
</script>
